var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnv02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_13227_36107)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.45703,
    y: 5,
    width: 40,
    height: 40,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.95703,
    y: 5.5,
    width: 39,
    height: 39,
    rx: 4.5,
    stroke: "#06513D",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8789 20.4932C29.2868 20.4932 29.6576 20.5305 29.8564 20.5635L29.6289 23.4961L29.6299 23.501C29.6339 23.52 29.6364 23.5375 29.6387 23.5527C29.6398 23.5601 29.6403 23.5671 29.6416 23.5732C29.6429 23.5791 29.6449 23.5857 29.6475 23.5908C29.6501 23.596 29.6558 23.6035 29.665 23.6055C29.6738 23.6073 29.6813 23.6032 29.6865 23.5996C29.6969 23.5925 29.7095 23.5784 29.7246 23.5576L29.7256 23.5566L31.3105 21.0498C31.6469 21.2241 32.0794 21.4816 32.4355 21.8027C32.7951 22.127 33.0739 22.5142 33.1025 22.9434L31.7451 27.041L31.7383 27.0605L31.7588 27.0615L35.2461 27.3145L37.4961 31.9434L36.3252 33.0225L36.3086 33.0381L36.3281 33.0479L38.0645 33.9365L39.9766 37.0771L36.1289 38.6846L31.5742 37.0195L31.5654 37.0156L31.5586 37.0225L30.0684 38.3877L25.8252 38.9834L22.0771 37.2109L22.0781 37.209L22.0684 37.21L17.416 37.8008L13.0332 35.9492L16.1104 34.0391L16.1182 34.0342L16.1172 34.0254L15.8926 29.8613L18.748 28.5361L18.7588 28.5312L18.7568 28.5195L18.3789 26.2051L21.3486 25.123V25.124L21.3535 25.1201L24.0244 22.627L26.1904 24.0791L26.1865 24.084L26.2012 24.082L26.2627 24.0703L26.2725 24.0684L26.2754 24.0596L27.2988 20.9902V20.9893C27.3606 20.7953 27.5793 20.6706 27.875 20.5947C28.1696 20.5192 28.5354 20.4932 28.8789 20.4932ZM24.1123 23.8799L22.1934 25.6719L22.1797 25.6846L22.1953 25.6953L23.2715 26.4707L20.7725 26.377V26.376L20.7666 26.3779L19.4854 26.8457L19.4736 26.8506L19.4756 26.8633L19.834 29.0654L19.8496 29.0635L19.8311 29.0664L19.8369 29.0732L20.749 30.1211L20.7412 30.1279L20.7617 30.126L22.8975 29.9775L20.9473 31.6875L19.0781 29.4756L19.0703 29.4658L19.0596 29.4717L16.9131 30.4688L16.9033 30.4727L16.9043 30.4834L17.124 34.5684L15.1885 35.7705L15.1621 35.7861L15.1904 35.7979L17.5488 36.7949L17.5479 36.7969L17.5566 36.7959L22.2363 36.1934L25.9736 37.9668L25.9727 37.9688L25.9824 37.9678L29.6299 37.4609L29.6309 37.4639L29.6387 37.457L31.3486 35.8916L36.1006 37.623L36.0986 37.6289L36.1123 37.623L38.5293 36.6143L38.5459 36.6074L38.5361 36.5918L37.3838 34.6934L37.3867 34.6924L37.3779 34.6875L34.6172 33.2783L36.2959 31.7217L36.3047 31.7139L36.2998 31.7041L35.8574 30.791L35.8535 30.7832L35.8438 30.7822L32.1699 30.6123L35.3604 29.8164L35.3789 29.8115L35.3711 29.7939L34.6211 28.2617L34.6172 28.2539L34.6084 28.2529L31.0498 27.9941L31.0508 27.9893L31.04 27.9971L27.6611 30.416L25.4365 27.7305L27.7988 28.6436L27.8066 28.6465L27.8125 28.6426L29.8047 27.3408L29.8145 27.335L29.8105 27.3232L29.0049 24.6367L29.001 24.623L28.9873 24.626L25.9775 25.1201L24.1318 23.8789L24.1221 23.8721L24.1123 23.8799ZM28.9277 35.7451L26.1895 33.3926L28.1455 34.1699L28.1436 34.1738L28.1553 34.1699L31.7939 33.0518L28.9277 35.7451ZM24.2646 35.2314L21.2236 35.3838L19.0586 34.0449L24.2646 35.2314ZM34.0088 12.0156L31.3857 19.9326C31.0975 19.8079 30.7835 19.7045 30.459 19.6221L32.9785 12.0156H34.0088Z",
    fill: "#06513D",
    stroke: "#06513D",
    strokeWidth: 0.03125
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_13227_36107",
    x: 0.257031,
    y: 0.8,
    width: 52.4,
    height: 52.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.529412 0 0 0 0 0.639216 0 0 0 0.52 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_13227_36107"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_13227_36107",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnv02);
export default __webpack_public_path__ + "static/media/Env02.7bdd65241b7d3db49db474ba8a481a8f.svg";
export { ForwardRef as ReactComponent };